import React from "react";
import { Box } from "@mui/material";
import VoiceLiveDemo from "./VoiceLiveDemo";

// Legacy Python (insurance_claim_live_agent_team / live_demo/server.py):
// const voicePageBaseUrl =
//   process.env.REACT_APP_CHAT_GEMINI_LIVE_URL || "http://127.0.0.1:8002";
// const src = voicePageBaseUrl.replace(/\/$/, "");
// <iframe
//   title="Insurance Claim Voice Intake"
//   src={src}
//   style={{ width: "100%", height: "100%", border: "none" }}
//   allow="microphone"
// />

const VoiceForms: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "calc(100vh - 60px)",
        overflow: "hidden",
      }}
    >
      <VoiceLiveDemo />
    </Box>
  );
};

export default VoiceForms;
